import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Mail, Phone, MapPin, Clock, Send } from 'lucide-react';
import { Badge } from '../components/Badge';
export function Contact() {
  return <div className="w-full" data-id="element-314">
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-b from-white via-slate-50 to-indigo-50/30" data-id="element-315">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-316">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-317">
            <Badge icon={<MessageSquare className="w-3.5 h-3.5" data-id="element-319" />} text="CONTACT US" data-id="element-318" />

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black leading-[1.1] tracking-tight mb-6" data-id="element-320">
              Let's Start a{' '}
              <span className="text-gradient-blue-violet" data-id="element-321">Conversation</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-322">
              Have a project in mind or want to see Akios BOS in action? We'd
              love to hear from you. Our team typically responds within 2 hours.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Info Cards Section */}
      <section className="py-8 relative z-10 -mt-8" data-id="element-323">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-324">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-325">
            {[{
            icon: Mail,
            label: 'EMAIL US',
            value: 'akiosventure@gmail.com',
            sub: 'We reply within 24 hours',
            color: 'text-blue-600',
            bg: 'bg-blue-50'
          }, {
            icon: Phone,
            label: 'CALL US',
            value: '+91 82486 63500',
            sub: 'Mon–Fri, 10am–7pm IST',
            color: 'text-green-600',
            bg: 'bg-green-50'
          }, {
            icon: MapPin,
            label: 'VISIT US',
            value: 'Chennai, Tamil Nadu',
            sub: 'India',
            color: 'text-amber-600',
            bg: 'bg-amber-50'
          }, {
            icon: Clock,
            label: 'OFFICE HOURS',
            value: '10:00 AM – 7:00 PM',
            sub: 'Monday to Friday (IST)',
            color: 'text-purple-600',
            bg: 'bg-purple-50'
          }].map((card, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.2 + i * 0.1
          }} className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-326">
                <div className={`p-3 rounded-xl shrink-0 ${card.bg} ${card.color}`} data-id="element-327">
                  <card.icon className="w-6 h-6" data-id="element-328" />
                </div>
                <div data-id="element-329">
                  <div className="text-[10px] font-bold text-slate-400 tracking-wider uppercase mb-1" data-id="element-330">
                    {card.label}
                  </div>
                  <div className="font-bold text-slate-900 mb-1" data-id="element-331">
                    {card.value}
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-332">{card.sub}</div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-16 bg-white" data-id="element-333">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-334">
          <div className="grid lg:grid-cols-2 gap-16 items-start" data-id="element-335">
            {/* Form */}
            <div className="bg-white rounded-3xl border border-slate-200 p-8 shadow-xl shadow-slate-200/40" data-id="element-336">
              <h3 className="text-2xl font-bold mb-6" data-id="element-337">Send us a message</h3>
              <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-338">
                <div className="grid sm:grid-cols-2 gap-5" data-id="element-339">
                  <div className="space-y-1.5" data-id="element-340">
                    <label className="text-sm font-semibold text-slate-700" data-id="element-341">
                      First Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all bg-slate-50 focus:bg-white" placeholder="John" data-id="element-342" />
                  </div>
                  <div className="space-y-1.5" data-id="element-343">
                    <label className="text-sm font-semibold text-slate-700" data-id="element-344">
                      Last Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all bg-slate-50 focus:bg-white" placeholder="Doe" data-id="element-345" />
                  </div>
                </div>

                <div className="space-y-1.5" data-id="element-346">
                  <label className="text-sm font-semibold text-slate-700" data-id="element-347">
                    Work Email
                  </label>
                  <input type="email" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all bg-slate-50 focus:bg-white" placeholder="john@company.com" data-id="element-348" />
                </div>

                <div className="space-y-1.5" data-id="element-349">
                  <label className="text-sm font-semibold text-slate-700" data-id="element-350">
                    Company Name
                  </label>
                  <input type="text" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all bg-slate-50 focus:bg-white" placeholder="Acme Inc." data-id="element-351" />
                </div>

                <div className="space-y-1.5" data-id="element-352">
                  <label className="text-sm font-semibold text-slate-700" data-id="element-353">
                    How can we help?
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 outline-none transition-all bg-slate-50 focus:bg-white resize-none" placeholder="Tell us about your project or inquiry..." data-id="element-354"></textarea>
                </div>

                <button type="submit" className="w-full bg-brand-blue hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg shadow-blue-600/20 flex items-center justify-center gap-2" data-id="element-355">
                  Send Message
                  <Send className="w-5 h-5" data-id="element-356" />
                </button>
              </form>
            </div>

            {/* FAQ / Info */}
            <div className="lg:py-8" data-id="element-357">
              <h3 className="text-3xl font-bold mb-8" data-id="element-358">
                Frequently Asked Questions
              </h3>
              <div className="space-y-6" data-id="element-359">
                {[{
                q: 'What is Akios BOS?',
                a: 'Akios BOS is our flagship Business Operating System, an all-in-one platform designed to unify inventory, CRM, finance, and operations for modern SMBs.'
              }, {
                q: 'Do you offer custom software development?',
                a: 'Yes, our Product Engineering team specializes in building scalable, custom digital solutions tailored to your specific business needs.'
              }, {
                q: 'How long does it take to deploy Akios BOS?',
                a: 'Most businesses can be fully set up and operational on Akios BOS within 24 hours, with no dedicated IT team required.'
              }, {
                q: 'Where are you located?',
                a: 'We are headquartered in Chennai, Tamil Nadu, India, but we work with clients globally.'
              }].map((faq, i) => <div key={i} className="border-b border-slate-200 pb-6 last:border-0" data-id="element-360">
                    <h4 className="text-lg font-bold text-slate-900 mb-2" data-id="element-361">
                      {faq.q}
                    </h4>
                    <p className="text-slate-600 leading-relaxed" data-id="element-362">{faq.a}</p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}